class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {

    
    document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });


  // ✅ accessories はDOM差し替え直後に遅延実行（今まで通り）
  setTimeout(() => {
    this.renderAccessories?.(parsedState);
  }, 0);

    this.stripCountFromCartButton(); //カートを見るの数字を消す関数

    // 追加したサマリー（下部固定）の点数・合計を更新
    this.updateCartNotificationSummary(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }
  

  async renderAccessories(parsedState, retry = 0) {
    const box = this.notification?.querySelector('.cart-notification__accessories');
    if (!box) return;

    const recommendArea =
      this.notification?.querySelector('.cart-notification__recommend');

    // ------------------------------------------------------------
    // 事前に商品ページ側（Liquid）で生成しておいたおすすめHTMLを取得する
    // 例：<template id="CartNotificationAccessoriesTemplate">...</template>
    // ※ ここではネットワークfetchを行わない（遅延/チラつき防止）
    // ------------------------------------------------------------
    const tpl = document.getElementById('CartNotificationAccessoriesTemplate');
    const html = tpl ? (tpl.innerHTML || '').trim() : '';

    // HTMLを差し込む（おすすめが無い場合は空のまま）
    box.innerHTML = html;

    // おすすめ商品が1件以上ある場合のみ「表示状態（is-active）」にする
    const hasItems = !!(html && box.querySelector('.cart-notification__acc-item'));

    if (hasItems) {
      recommendArea?.classList.add('is-active');
      // ✅ 中身があるときだけおすすめ枠自体を表示
      // （h3見出し等が残って空白が目立つのを防ぐ）
      if (recommendArea) recommendArea.hidden = false;
    } else {
      recommendArea?.classList.remove('is-active');
      // ✅ 0件ならおすすめ枠ごと非表示
      if (recommendArea) recommendArea.hidden = true;
    }
  }


  getHandleFromParsedState(parsedState) {
    if (!parsedState) return null;

    // ありがちなパターン：product_url が入っている
    const url =
      parsedState.product_url ||
      parsedState.url ||
      (parsedState.items && parsedState.items[0] && (parsedState.items[0].url || parsedState.items[0].product_url)) ||
      null;

    if (url) {
      const m = String(url).match(/\/products\/([^\/\?#]+)/);
      if (m) return m[1];
    }

    // ありがちなパターン：handle が直で入っている
    const handle =
      parsedState.product_handle ||
      parsedState.handle ||
      (parsedState.items && parsedState.items[0] && (parsedState.items[0].handle || parsedState.items[0].product_handle)) ||
      null;

    return handle ? String(handle) : null;
  }


  getAddedProductHandle() {
    // 直前に追加された商品DOMを取得
    const itemEl = this.notification?.querySelector(
      `[id="cart-notification-product-${this.cartItemKey}"]`
    );
    if (!itemEl) return null;

    // 商品リンク（/products/handle）を探す
    const link = itemEl.querySelector('a[href*="/products/"]');
    if (!link) return null;

    const href = link.getAttribute('href') || '';
    const match = href.match(/\/products\/([^\/\?#]+)/);

    return match ? match[1] : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      // ShopifyのAJAX cart更新時に、下記のliquid (カート通知内下部のsummary[〇点 合計X円]) の情報も更新する
      { 
        id: 'cart-notification-summary' 
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  stripCountFromCartButton() {
    const btn = document.getElementById('cart-notification-button');
    if (!btn) return;
    //  "カートを見る(10)" の数字だけ消す
    btn.textContent = btn.textContent.replace(/\s*\(\d+\)\s*$/, '');
  }

  /**
   * cart-notification 下部固定サマリー更新
   * - 点数: できるだけ cart-icon-bubble（Dawnが必ず更新する）を優先
   * - 合計: cart.js から取得（1リクエスト）
   */
  updateCartNotificationSummary(parsedState) {
    // 差し替え直後はレイアウト/DOMが安定していないことがあるので1tick遅らせる
    this.updateSummaryLater();
  }

  updateSummaryLater() {
    var self = this;
    window.setTimeout(function () {
      // self.updateSummaryFromBubble();  ← これを消す（またはコメントアウト）
      self.updateSummaryFromCartJS();
    }, 0);
  }

  updateSummaryFromBubble() {
    if (!this.notification) return;
    var summary = this.notification.querySelector('.cart-notification__summary');
    if (!summary) return;

    var countEl = summary.querySelector('.cart-notification__summary-count');
    if (!countEl) return;

    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    // Dawn系: cart-icon-bubble の中に
    //  - <span aria-hidden="true">9</span>
    //  - <span class="visually-hidden">9 items</span>
    // が入っており、textContent をそのまま拾うと "99" になりがち。
    var countSpan = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child');
    var raw = countSpan ? countSpan.textContent : bubble.textContent;
    var m = String(raw || '').match(/\d+/);
    if (!m) return;

    var count = m[0];
    // Liquid側が「{{ cart.item_count }}点 合計」形式なら、接尾辞を残して先頭数字だけ置換
    var current = String(countEl.textContent || '');
    if (/点/.test(current)) {
      countEl.textContent = current.replace(/^\d+/, count);
    } else {
      countEl.textContent = count + '点 合計';
    }
  }

  updateSummaryFromCartJS() {
  if (!this.notification) return;

  // portalしてても拾えるように document 側で取るのが無難
  var summary = document.querySelector('.cart-notification__summary');
  if (!summary) return;

  var totalEl = summary.querySelector('.cart-notification__summary-total');
  var countEl = summary.querySelector('.cart-notification__summary-count');

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      // 点数もここで確定値を入れる（ズレ防止）
      if (countEl) countEl.textContent = String(cart.item_count) + '点 合計';

      // 合計更新（あなたの既存処理のままでOK）
      var moneyFormat =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify && Shopify.money_format) ||
        '¥{{amount_no_decimals}}';

      if (moneyFormat && moneyFormat.indexOf('amount_no_decimals') === -1) {
        moneyFormat = moneyFormat.replace(/amount(_with_[a-z_]+)?/g, 'amount_no_decimals');
      }

      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        if (totalEl) totalEl.textContent = Shopify.formatMoney(cart.total_price, moneyFormat);
        return;
      }

      var yen = Math.round(Number(cart.total_price || 0) / 100);
      if (totalEl) totalEl.textContent = '¥' + String(yen).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    })
    .catch(function () {});
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


/* =========================================================
 * cart-notification accessories ajax add-to-cart (append only)
 * 対象: form.cart-notification__acc-form
 * 目的: ページ遷移せず追加 → cart-icon-bubble / cart-notification-button / 下部summary更新
 * ========================================================= */
(function () {
  if (typeof document === 'undefined') return;

  function getRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function formatMoneySafe(cents) {
    // Dawn系があればそれを優先（小数点は出さない）
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        var fmt =
          (window.theme && window.theme.moneyFormat) ||
          (typeof Shopify !== 'undefined' && Shopify.money_format) ||
          '¥{{amount_no_decimals}}';

        // 末尾が amount 系なら amount_no_decimals に寄せて小数点を出さない
        // 例: ¥{{amount}} / ¥{{amount_with_comma_separator}} -> ¥{{amount_no_decimals}}
        if (fmt && fmt.indexOf('amount_no_decimals') === -1) {
          fmt = fmt.replace(/amount(_with_[a-z_]+)?/g, 'amount_no_decimals');
        }
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}

    // フォールバック：JPY前提（Shopifyの金額は基本「最小通貨単位」＝円*100 で来るので 100 で割る）
    var n = Math.round((Number(cents) || 0) / 100);
    return '¥' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function replaceSectionById(sectionHtml, id) {
    if (!sectionHtml) return;
    var current = document.getElementById(id);
    if (!current) return;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.getElementById(id);
    if (!fresh) return;

    // idが同じ要素を丸ごと差し替え（aタグでもOK）
    current.outerHTML = fresh.outerHTML;
  }

  function updateBottomSummaryFromCart(cartJson) {
    var summary = document.querySelector('.cart-notification__summary');
    if (!summary) return;

    var countEl = summary.querySelector('.cart-notification__summary-count');
    var totalEl = summary.querySelector('.cart-notification__summary-total');
    if (countEl) countEl.textContent = String(cartJson.item_count) + '点 合計';
    if (totalEl) totalEl.textContent = formatMoneySafe(cartJson.total_price);
  }

  function refreshHeaderSectionsThenSummary() {
    // Dawnの「sectionsレンダリングAPI」で、上部カート数/ボタンを更新
    var root = getRoot();
    var url = root + '?sections=cart-icon-bubble,cart-notification-button&sections_url=' + encodeURIComponent(window.location.pathname);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['cart-icon-bubble']) {
          replaceSectionById(sections['cart-icon-bubble'], 'cart-icon-bubble');
        }
        if (sections && sections['cart-notification-button']) {
          replaceSectionById(sections['cart-notification-button'], 'cart-notification-button');
        }
      })
      .catch(function () { /* 失敗しても致命ではない */ });
  }

  function fetchCartAndUpdateSummary() {
    return fetch(getRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cartJson) {
        updateBottomSummaryFromCart(cartJson);
      })
      .catch(function () { /* 失敗しても致命ではない */ });
  }

  // 送信を横取り（遷移を止める）
  document.addEventListener('submit', function (e) {
    console.log('acc add submit fired'); // ログ追記

    var form = e.target;
    if (!form || !form.classList) return;
    if (!form.classList.contains('cart-notification__acc-form')) return;

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading'); // 必要ならCSSでスピナー表示などに使える
    }

    // /cart/add.js に投げる（JSONが返る）
    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed');
        return r.json();
      })
      .then(function () {

        // ★ここ：ヘッダーのカートバブルを最新状態に更新
fetch('/cart.js')
  .then(function (r) { return r.json(); })
  .then(function (cart) {
        var root = document.getElementById('cart-icon-bubble');
        if (!root) return;
        var wrap = root.querySelector('.cart-count-bubble');
        // 0件ならバブル自体を消す（liquidと同じ挙動）
        if (!cart.item_count || cart.item_count <= 0) {
          if (wrap) wrap.remove();
          return;
        }
        // バブルが無ければ作る（liquid構造に寄せる）
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'cart-count-bubble';

          var num = document.createElement('span');
          num.setAttribute('aria-hidden', 'true');

          var vh = document.createElement('span');
          vh.className = 'visually-hidden';

          wrap.appendChild(num);
          wrap.appendChild(vh);
          root.appendChild(wrap);
        }

        // 数字（100以上はliquidだと数字非表示なので合わせる）
        var numEl = wrap.querySelector('span[aria-hidden="true"]');
        if (numEl) numEl.textContent = (cart.item_count < 100) ? String(cart.item_count) : '';

        // visually-hidden は既存文言を壊さず「数字だけ」差し替え（無理なら最低限更新）
        var vhEl = wrap.querySelector('.visually-hidden');
        if (vhEl) {
          if (vhEl.textContent && /\d+/.test(vhEl.textContent)) {
            vhEl.textContent = vhEl.textContent.replace(/\d+/, String(cart.item_count));
          } else {
            // 既存が空/想定外なら最低限
            vhEl.textContent = String(cart.item_count);
          }
        }
      });
        // 1) 上部のカート数/ボタンをDawn同様に更新
        return refreshHeaderSectionsThenSummary();
      })
      .then(function () {
        // 2) 下部固定サマリー（点数/合計）を確実に更新
        return fetchCartAndUpdateSummary();
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
  }, true);
})();


/* =========================================================
 * append only: cart-notification open中は言語バーを隠す
 * 対象: .fixed-lang-selector
 * ========================================================= */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // cart-notification のコンストラクタ取得
  var CartNotificationCtor = customElements.get('cart-notification');
  if (!CartNotificationCtor || !CartNotificationCtor.prototype) return;

  var proto = CartNotificationCtor.prototype;

  // 二重パッチ防止
  if (proto.__cmLangBarPatched) return;
  proto.__cmLangBarPatched = true;

  function setCartOpenState(isOpen) {
    document.body.classList.toggle('cm-cart-notification-open', !!isOpen);
  }

  // 元の open/close を退避してラップ
  var originalOpen = proto.open;
  var originalClose = proto.close;

  proto.open = function () {
    try { setCartOpenState(true); } catch (e) {}
    return originalOpen.apply(this, arguments);
  };

  proto.close = function () {
    try { setCartOpenState(false); } catch (e) {}
    return originalClose.apply(this, arguments);
  };
})();



/* ==========================================================================
 * cart-notification__summary を body 直下へと DOM操作(移動)させて
 * iOSで URLバーが大きい時に summary が下に隠れる問題を改善
 * ※ SP(<=750px) の時だけ有効
 * ※ 現在､このズレは許容範囲として一旦コメントアウト========================================================================== */
// (() => {
//   if (typeof window === 'undefined' || typeof document === 'undefined') return;

//   const ROOT_ID = 'cart-notification';
//   const SUMMARY_SEL = '.cart-notification__summary';
//   const MOBILE_MQ = '(max-width: 750px)';

//   const root = document.getElementById(ROOT_ID);
//   if (!root) return;

//   const state = {
//     mounted: false,
//     summaryEl: null,
//     placeholder: null,
//     originalParent: null,
//     originalNext: null,
//     raf: 0,
//   };

//   const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

//   const isOpen = () =>
//     root.classList.contains('active') || root.getAttribute('aria-hidden') === 'false';

//   const getSummaryInRoot = () => root.querySelector(SUMMARY_SEL);

//   // 「見えてる領域(visual viewport)」が layout viewport より小さい分(px) = URLバー等の被り推定
//   const getUrlBarGap = () => {
//     const vv = window.visualViewport;
//     if (!vv) return 0;
//     const layoutH = window.innerHeight || 0;
//     const visualH = vv.height || 0;
//     const gap = Math.max(0, Math.round(layoutH - visualH));
//     return gap;
//   };

//   const cancelRaf = () => {
//     if (state.raf) cancelAnimationFrame(state.raf);
//     state.raf = 0;
//   };

//   const scheduleApply = () => {
//     cancelRaf();
//     state.raf = requestAnimationFrame(applyPositionAndPadding);
//   };

//   function ensureMounted() {
//     // ✅ SP以外は portal しない（PCでは不要）
//     if (!isMobile()) return;

//     if (state.mounted) return;

//     const summary = getSummaryInRoot();
//     if (!summary) return;

//     // 元の位置を記憶して戻せるようにする
//     state.summaryEl = summary;
//     state.originalParent = summary.parentNode;
//     state.originalNext = summary.nextSibling;

//     // 置換用プレースホルダ
//     const ph = document.createElement('div');
//     ph.setAttribute('data-summary-placeholder', 'true');
//     ph.style.height = `${summary.getBoundingClientRect().height}px`;
//     state.placeholder = ph;
//     state.originalParent.insertBefore(ph, state.originalNext);

//     // body直下へ
//     document.body.appendChild(summary);

//     // まずは「見せない」で固定化（※これで出現時のチラつき/上に飛ぶのを抑える）
//     summary.style.position = 'fixed';
//     summary.style.left = '0px';
//     summary.style.bottom = '0px';
//     summary.style.width = '0px';
//     summary.style.transform = 'translateZ(0)';
//     summary.style.zIndex = '9999';
//     summary.style.opacity = '0';
//     summary.style.pointerEvents = 'none';

//     state.mounted = true;
//     scheduleApply();
//   }

//   function unmount() {
//     if (!state.mounted || !state.summaryEl) return;

//     cancelRaf();

//     // 元のDOM位置へ戻す
//     try {
//       if (state.placeholder && state.placeholder.parentNode) {
//         state.placeholder.parentNode.insertBefore(state.summaryEl, state.placeholder);
//         state.placeholder.remove();
//       } else if (state.originalParent) {
//         state.originalParent.insertBefore(state.summaryEl, state.originalNext);
//       }
//     } catch (e) {}

//     // style を戻す
//     state.summaryEl.style.position = '';
//     state.summaryEl.style.left = '';
//     state.summaryEl.style.bottom = '';
//     state.summaryEl.style.width = '';
//     state.summaryEl.style.transform = '';
//     state.summaryEl.style.zIndex = '';
//     state.summaryEl.style.opacity = '';
//     state.summaryEl.style.pointerEvents = '';

//     state.mounted = false;
//     state.summaryEl = null;
//     state.placeholder = null;
//     state.originalParent = null;
//     state.originalNext = null;

//     // scroll領域の余白も戻す（必要なら）
//     root.style.paddingBottom = '';
//   }

//   function applyPositionAndPadding() {
//     if (!state.mounted || !state.summaryEl) return;

//     // 開いてない時は絶対に見せない（ここが「初期から見えてる」の保険）
//     if (!isOpen()) {
//       state.summaryEl.style.opacity = '0';
//       state.summaryEl.style.pointerEvents = 'none';
//       return;
//     }

//     const rect = root.getBoundingClientRect();

//     // root の幅に合わせて summary も合わせる（左右の余白ルールを壊さない）
//     state.summaryEl.style.left = `${Math.round(rect.left)}px`;
//     state.summaryEl.style.width = `${Math.round(rect.width)}px`;

//     // URLバーで隠れる分だけ持ち上げ
//     const gap = getUrlBarGap();
//     state.summaryEl.style.bottom = `${gap}px`;

//     // scroll領域の最下部が summary に隠れないよう padding を付ける
//     const h = Math.round(state.summaryEl.getBoundingClientRect().height);
//     root.style.paddingBottom = `${h + gap}px`;

//     // 位置が決まったら表示
//     state.summaryEl.style.opacity = '1';
//     state.summaryEl.style.pointerEvents = 'auto';
//   }

//   // --- CartNotification の open/close をフック（Dawn系） ---
//   const CartNotificationCtor = customElements.get('cart-notification');
//   if (!CartNotificationCtor || !CartNotificationCtor.prototype) return;

//   const proto = CartNotificationCtor.prototype;

//   // 二重パッチ防止
//   if (proto.__cmSummaryPortalPatched) return;
//   proto.__cmSummaryPortalPatched = true;

//   const originalOpen = proto.open;
//   const originalClose = proto.close;

//   function setCartOpenState(isOpenBool) {
//     // あなたの既存実装があるならクラス名は揃えてOK（例：cm-cart-notification-open）
//     document.body.classList.toggle('cm-cart-notification-open', !!isOpenBool);
//   }

//   proto.open = function () {
//     try {
//       setCartOpenState(true);

//       // ✅ SPの時だけ portal
//       if (isMobile()) ensureMounted();
//       else unmount();

//       // 開く直前/直後に何回か合わせる（アニメやレイアウト確定のズレ吸収）
//       scheduleApply();
//       setTimeout(scheduleApply, 0);
//       setTimeout(scheduleApply, 120);
//       setTimeout(scheduleApply, 300);
//     } catch (e) {}

//     return originalOpen ? originalOpen.apply(this, arguments) : undefined;
//   };

//   proto.close = function () {
//     try {
//       setCartOpenState(false);
//       unmount(); // ✅ Xでも close を通るならここで確実に消える
//     } catch (e) {}

//     return originalClose ? originalClose.apply(this, arguments) : undefined;
//   };

//   // --- 保険：close() を経由しない閉じ方（Xやoverlay等）でも必ず unmount ---
//   document.addEventListener(
//     'click',
//     (e) => {
//       const el = e.target instanceof Element ? e.target : null;
//       if (!el) return;

//       // Xボタン（あなたの環境に合わせて selector を追加OK）
//       if (el.closest('.cart-notification__close, .cart-notification__close-button, .cart-notification__close-button .icon-close')) {
//         setTimeout(() => {
//           setCartOpenState(false);
//           unmount();
//         }, 0);
//         return;
//       }

//       // overlay（あなたの環境に合わせて selector を追加OK）
//       if (el.closest('.cm-cart-overlay, .modal-overlay, .overlay')) {
//         setTimeout(() => {
//           setCartOpenState(false);
//           unmount();
//         }, 0);
//       }
//     },
//     true
//   );

//   // viewport変化で追従
//   window.addEventListener('resize', scheduleApply, { passive: true });
//   if (window.visualViewport) {
//     window.visualViewport.addEventListener('resize', scheduleApply, { passive: true });
//     window.visualViewport.addEventListener('scroll', scheduleApply, { passive: true });
//   }

//   // PC↔SP 切り替え時も破綻しないように
//   const mq = window.matchMedia(MOBILE_MQ);
//   mq.addEventListener?.('change', () => {
//     if (!isMobile()) unmount();
//     else scheduleApply();
//   });

//   // 初期状態で開いてないなら見せない（保険）
//   if (!isOpen()) {
//     // portal済みなら消す、未portalなら何もしない
//     scheduleApply();
//   }
// })();
